import { render, staticRenderFns } from "./AddCrew.vue?vue&type=template&id=635f0a44&scoped=true"
import script from "./AddCrew.vue?vue&type=script&lang=js"
export * from "./AddCrew.vue?vue&type=script&lang=js"
import style0 from "./AddCrew.vue?vue&type=style&index=0&id=635f0a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f0a44",
  null
  
)

export default component.exports